import { createContext, useContext } from "react";

const InsideDialogContext = createContext(false);

export function useInsideDialog(): boolean {
  return useContext(InsideDialogContext);
}

export { InsideDialogContext };
